const iniciarFormularioLiquidacion = () => {
    const formulario = document.querySelector(
        '#formulario-liquidacion'
    );

    if (!formulario) {
        return;
    }

    const dniInput = formulario.querySelector('#dni');

    const nombreInput = formulario.querySelector(
        '#nombre_completo'
    );

    const mensaje = formulario.querySelector(
        '#mensaje-dni-liquidacion'
    );

    const botonRegistrar = formulario.querySelector(
        'button[type="submit"]'
    );

    if (
        !dniInput ||
        !nombreInput ||
        !mensaje ||
        !botonRegistrar
    ) {
        console.error(
            'Faltan elementos del formulario de liquidación.'
        );

        return;
    }

    let ultimaConsulta = '';

    const consultarIdentidad = async () => {
        const dni = dniInput.value.replace(/\D/g, '');

        dniInput.value = dni;

        if (dni.length !== 13) {
            nombreInput.value = '';
            botonRegistrar.disabled = true;

            mensaje.textContent =
                'Ingrese los 13 dígitos de la identidad.';

            mensaje.className =
                'mensaje-form pendiente';

            return;
        }

        /*
         * Si la identidad ya fue consultada y el nombre
         * continúa lleno, no volvemos a consultar ni
         * borramos el autollenado.
         */
        if (
            ultimaConsulta === dni &&
            nombreInput.value.trim() !== ''
        ) {
            return;
        }

        nombreInput.value = '';
        botonRegistrar.disabled = true;

        ultimaConsulta = dni;

        mensaje.textContent =
            'Consultando identidad...';

        mensaje.className =
            'mensaje-form pendiente';

        try {
            const url =
                `/index.php/liquidaciones/buscar-dni?dni=${encodeURIComponent(dni)}`;

            const respuesta = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                },
                credentials: 'same-origin'
            });

            if (!respuesta.ok) {
                throw new Error(
                    `Error HTTP ${respuesta.status}`
                );
            }

            const textoRespuesta =
                await respuesta.text();

            let datos;

            try {
                datos = JSON.parse(textoRespuesta);
            } catch (error) {
                console.error(
                    'Respuesta recibida:',
                    textoRespuesta
                );

                throw new Error(
                    'El servidor no devolvió JSON válido.'
                );
            }

            if (!datos.encontrado) {
                nombreInput.value = '';
                botonRegistrar.disabled = true;

                mensaje.textContent =
                    datos.mensaje
                    || 'Identidad no encontrada.';

                mensaje.className =
                    'mensaje-form error';

                return;
            }

            nombreInput.value = datos.nombre || '';

            if (datos.tiene_liquidacion) {
                botonRegistrar.disabled = true;

                mensaje.innerHTML = `
                    <strong>
                        Esta identidad ya tiene una
                        liquidación registrada.
                    </strong>
                    <br>
                    Nombre: ${datos.nombre}
                    <br>
                    Contrato: ${datos.contrato}
                    <br>
                    Cargo: ${datos.cargo}
                    <br>
                    Monto: L ${datos.monto}
                    <br>
                    Estado: ${datos.estado}
                    ${datos.fecha
                        ? `<br>Registrada el: ${datos.fecha}`
                        : ''}
                `;

                mensaje.className =
                    'mensaje-form error';

                return;
            }

            botonRegistrar.disabled = false;

            mensaje.textContent =
                datos.mensaje;

            mensaje.className =
                'mensaje-form success';

        } catch (error) {
            console.error(error);

            ultimaConsulta = '';
            nombreInput.value = '';
            botonRegistrar.disabled = true;

            mensaje.textContent =
                'No se pudo consultar la identidad. Intente nuevamente.';

            mensaje.className =
                'mensaje-form error';
        }
    };

    dniInput.addEventListener('input', () => {
        ultimaConsulta = '';

        dniInput.value = dniInput.value.replace(
            /\D/g,
            ''
        );

        nombreInput.value = '';
        botonRegistrar.disabled = true;

        if (dniInput.value.length === 13) {
            consultarIdentidad();
        } else {
            mensaje.textContent =
                'Ingrese los 13 dígitos de la identidad.';

            mensaje.className =
                'mensaje-form pendiente';
        }
    });

    dniInput.addEventListener(
        'blur',
        consultarIdentidad
    );
};

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        iniciarFormularioLiquidacion
    );
} else {
    iniciarFormularioLiquidacion();
}